module.exports = __webpack_public_path__ + "titus.logo.1ddba.png";